export const breadcrumb = {
  title: 'Предиктивный обзвон',
  trunk: {
    index: ''
  }
};
